import { Form, Input, Select, Spin } from "antd";
import { observer } from "mobx-react";
import { useState } from "react";
import { useCallback } from "react";
import { __ } from "../../../../../utils";
import { RealCommerceError } from "../../../../../exceptions";
import { useRealCommerceErrorHandling } from "../../../../../hooks";
const AccountAddLicenseForm = observer(_ref => {
  let {
    onSave,
    edit,
    record
  } = _ref;
  const {
    productVariants,
    data: {
      id
    }
  } = record;
  const [busy, setBusy] = useState(false);
  const initialValues = edit ? {
    rpmProductVariantId: edit.data.productVariant.id,
    installationsProduction: edit.data.maxInstallationsProduction,
    installationsDevelopment: edit.data.maxInstallationsDevelopment,
    description: edit.data.description || ""
  } : {
    rpmProductVariantId: productVariants.length === 1 ? productVariants[0].data.id : "",
    installationsProduction: 1,
    installationsDevelopment: 1,
    description: ""
  };
  const [form] = Form.useForm();
  const handleRealCommerceError = useRealCommerceErrorHandling();
  const onFinish = useCallback(async values => {
    setBusy(true);
    try {
      if (edit) {
        await edit.update(values);
      } else {
        await record.addLicense(values);
      }
      form.resetFields();
      onSave === null || onSave === void 0 ? void 0 : onSave();
    } catch (e) {
      if (e instanceof RealCommerceError) {
        handleRealCommerceError(e);
      }
    } finally {
      setBusy(false);
    }
  }, [record]);
  return /*#__PURE__*/React.createElement(Spin, {
    spinning: busy
  }, /*#__PURE__*/React.createElement(Form, {
    form: form,
    name: edit ? `edit-license-form-${edit.data.id}` : `add-license-form-${id}`,
    onFinish: onFinish,
    initialValues: initialValues,
    layout: "vertical",
    labelWrap: true
  }, /*#__PURE__*/React.createElement(Form.Item, {
    label: __("Product"),
    name: "rpmProductVariantId",
    required: true,
    rules: [{
      type: "number",
      required: true,
      message: __("Please select a product!")
    }]
  }, /*#__PURE__*/React.createElement(Select, {
    disabled: !!edit
  }, productVariants.map(_ref2 => {
    let {
      data: {
        id,
        name
      }
    } = _ref2;
    return /*#__PURE__*/React.createElement(Select.Option, {
      key: id,
      value: id
    }, name);
  }))), /*#__PURE__*/React.createElement(Form.Item, {
    label: __("Maximum installations")
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      paddingLeft: 15,
      borderLeft: "1px solid #f0f3f7"
    }
  }, /*#__PURE__*/React.createElement(Form.Item, {
    label: __("Production"),
    name: "installationsProduction",
    getValueFromEvent: _ref3 => {
      let {
        currentTarget: {
          value
        }
      } = _ref3;
      return +value;
    },
    rules: [{
      type: "number",
      min: 0,
      max: 1000,
      required: true,
      transform: v => +v,
      message: __("Please input a valid number!")
    }],
    style: {
      marginBottom: 0
    }
  }, /*#__PURE__*/React.createElement(Input, {
    type: "number",
    style: {
      width: 100,
      float: "left",
      marginRight: 15
    }
  })), /*#__PURE__*/React.createElement(Form.Item, {
    label: __("Development"),
    name: "installationsDevelopment",
    getValueFromEvent: _ref4 => {
      let {
        currentTarget: {
          value
        }
      } = _ref4;
      return +value;
    },
    rules: [{
      type: "number",
      min: 0,
      required: true,
      transform: v => +v,
      message: __("Please input a valid number!")
    }],
    style: {
      marginBottom: 0
    }
  }, /*#__PURE__*/React.createElement(Input, {
    type: "number",
    style: {
      width: 100,
      float: "left"
    }
  })))), /*#__PURE__*/React.createElement(Form.Item, {
    label: __("Description"),
    name: "description"
  }, /*#__PURE__*/React.createElement(Input, null))));
});
export { AccountAddLicenseForm };